export default "__VITE_ASSET__B5$MDkIs__"